import { useEffect, useState } from "react";
import getLibrariesList from "../api/getLibrariesList";
import { useQuery, useQueryClient } from 'react-query';

const LibraryFilter = ({ onChange }) => {
  const {
    data: libraries = [],
    isLoading,
    refetch,
    error
  } = useQuery(
    ['libraries'], // Query key
    () => getLibrariesList(), // Query function
    {
      staleTime: 2 * 60 * 1000, // 2 minutes
      cacheTime: 5 * 60 * 1000, // 5 minutes
      enabled: true, // Enable the query on mount
      refetchOnWindowFocus: true,
    }
  );

  return (
    <div style={{ height: "100%" }}>
      <select
        style={{
          float: "left",
          height: "100%",
          border: "0",
          outline: "none",
          borderRadius: "8px",
          padding: "0.15rem 0.5rem",
          marginLeft: "3px",
          maxWidth: "10vw",
        }}
        name="libraryFilter"
        id="libraryFilter"
        onChange={onChange}
      >
        <option value={"none"} style={{ fontWeight: "bold" }}>
          Pokaż wszystkie
        </option>
        {libraries.map((lib, index) => (
          <option value={lib.publicKey} key={`${lib.publicKey}-${index}`}>
            {lib.libraryName}
          </option>
        ))}
      </select>
    </div >
  );
};

export default LibraryFilter;
